import { FullCLesson } from '@yandex-int/k-common';
import { Button, SimpleText, Text } from 'platform-components';
import { UI_KIT_TEXT_TYPOGRAPHY } from 'platform-components/constants';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { useMount } from 'react-use';
import ym from 'react-yandex-metrika';

import { useCreateLesson } from 'common.components/hooks/use-create-lesson';
import { actions as lessonActions } from 'common.components/lesson';
import * as lessonViewActions from 'common.components/lesson-view.store/actions';
import { ProgressArrow } from 'common.components/skill-stats/__progress-arrow/skill-stats__progress-arrow';
import { diagnosticsActions } from 'store/diagnostics/actions';
import { Diagnostic } from 'store/diagnostics/typings';
import { getTeamIdFromPath } from 'utils/path';

import './overview-banner__diagnostic.scss';

interface Props {
    courseId: number | null;
    diagnostic: Diagnostic;
}

export const DiagnosticBanner = ({ courseId, diagnostic }: Props) => {
    const { subject } = useParams<Record<string, string>>();
    const teamId = getTeamIdFromPath();
    const dispatch = useDispatch();

    const { isLessonCreationInProgress, createLesson } = useCreateLesson({ isDiagnostic: true });

    const handleButtonClick = async () => {
        const problems = diagnostic.problemsInfo.problems;
        const lessonName = diagnostic.problemsInfo.lessonName;
        const lessonMeta = diagnostic.problemsInfo.lessonMeta;

        const handleSuccess = (clessonId: number, clessonData: FullCLesson | null) => {
            // если teamId вдруг не оказалось, то после выдачи занятия баннер останется в состоянии диагностики
            if (teamId) {
                dispatch(diagnosticsActions.setLesson({ lesson: clessonData, subject, teamId }));
            }
            dispatch(lessonActions.setLesson({ lesson: clessonData }));
            dispatch(lessonViewActions.toggleModal(true));

            ym('reachGoal', 'diagnostic_template_to_modal', {
                course_id: courseId,
                subject,
            });
        };

        createLesson({ lessonName, lessonMeta, problems }, handleSuccess);
    };

    useMount(() => {
        ym('reachGoal', 'diagnostic_banner_shown', {
            course_id: courseId,
            subject,
        });
    });

    return (
        <>
            <div className="overview-banner__diagnostic">
                <div>
                    <Text
                        className="overview-banner__section-title"
                        typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphXLMedium}
                    >
                        <SimpleText
                            className="overview-banner__diagnostic-title"
                            id="courseView.overviewBanner.diagnostic.title"
                        />
                        <span className="overview-banner__diagnostic-diff">
                            <ProgressArrow isSuccess={true} />
                            <Text
                                className="overview-banner__diagnostic-diff-text"
                                typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphXLMedium}
                            >
                                <SimpleText id="courseView.overviewBanner.diagnostic.profit" />
                            </Text>
                        </span>
                    </Text>
                </div>
                <Text
                    id="courseView.overviewBanner.diagnostic.description"
                    typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphMRegular}
                />
            </div>
            <Button
                className="overview-banner__button"
                onClick={handleButtonClick}
                progress={isLessonCreationInProgress}
            >
                <SimpleText id="courseView.overviewBanner.diagnostic.button" />
            </Button>
        </>
    );
};
